<template>
  <Admin style="background: #f2f2f2">
    <v-main>
      <v-container fluid>
        <v-card class="rounded-xl tw-min-h-80">
          <div
            v-if="isLoading"
            class="tw-flex tw-items-center tw-justify-center tw-min-h-80"
          >
            <v-progress-circular
              color="primary"
              indeterminate
            ></v-progress-circular>
          </div>
          <v-card-text v-else>
            <div class="tw-flex tw-justify-between">
              <div
                class="tw-mx-5 tw-font-bold tw-text-xl tw-text-black tw-tracking-wide"
              >
                ตั้งค่า API
              </div>
              <v-btn
                color="primary"
                large
                outlined
                @click="startEditing"
                v-if="!isEditing"
              >
                <v-icon left>mdi-pencil</v-icon>
                แก้ไข
              </v-btn>
            </div>
            <div class="tw-mx-5">
              <v-form>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="settingAPI.apiKey"
                      class="tw-m-0 tw-pt-1"
                      dense
                      label="API Key"
                      outlined
                      :readonly="!isEditing"
                      :type="showApiKey ? 'text' : 'password'"
                    >
                      <template v-slot:append>
                        <v-btn icon @click="toggleApiKeyVisibility">
                          <v-icon>{{ showApiKey ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                        </v-btn>
                        <v-btn icon @click="copyApiKey">
                          <v-icon>mdi-content-copy</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" v-if="isEditing">
                    <v-btn
                      color="secondary"
                      outlined
                      @click="generateNewApiKey"
                    >
                      <v-icon left>mdi-refresh</v-icon>
                      Generate New API Key
                    </v-btn>
                  </v-col>
                </v-row>
                <div class="tw-flex tw-justify-end">
                  <v-btn
                    color="primary"
                    large
                    outlined
                    @click="isEditing = false"
                    v-if="isEditing"
                  >
                    <v-icon left>mdi-close</v-icon>
                    ยกเลิก
                  </v-btn>
                  <v-btn
                    :loading="isSaving"
                    color="primary"
                    large
                    @click="save"
                    v-if="isEditing"
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    บันทึก
                  </v-btn>
                </div>
              </v-form>
            </div>
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import Admin from "../../components/admin/admin-main-template";
import fc from "@/firebaseConfig";

export default {
  name: "SettingAPI",
  components: {
    Admin,
  },
  data: () => ({
    isLoading: false,
    isSaving: false,
    isEditing: false,
    showApiKey: false,
    settingAPI: {
      apiKey: "",
    },
  }),
  methods: {
    async save() {
      try {
        this.isSaving = true;
        const data = this.settingAPI;
        const userId = fc.auth.currentUser.uid;
        const companyId = this.$router.currentRoute.params.companyId;
        const companiesUsersPath = `/CompaniesUsers/${companyId}_${userId}`;

        console.log("companiesUsersPath path:", companiesUsersPath);

        await fc.db.doc(companiesUsersPath).set(data, { merge: true });

        console.log("Saved API configuration and updated company:", data);
      } finally {
        this.isSaving = false;
        this.isEditing = false;
      }
    },
    listenToAPISetting() {
      const companyId = this.$router.currentRoute.params.companyId;
      const userId = fc.auth.currentUser.uid;
      const companiesUsersPath = `/CompaniesUsers/${companyId}_${userId}`;
      const settingDoc = fc.db.doc(companiesUsersPath);

      this.isLoading = true;
      settingDoc.onSnapshot(
        (snapshot) => {
          const data = snapshot.data();
          if (snapshot.exists && data) {
            this.settingAPI = {
              apiKey: data.apiKey || "",
            };
          } else {
            this.settingAPI = {
              apiKey: "",
            };
          }
          this.isLoading = false;
        },
        (error) => {
          console.error(companiesUsersPath, error);
          this.isLoading = false;
        }
      );
    },
    startEditing() {
      this.isEditing = true;
      this.settingAPI.apiKey = this.generateRandomApiKey();
    },
    generateRandomApiKey() {
      const length = 128;
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let apiKey = '';
      for (let i = 0; i < length; i++) {
        apiKey += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      return apiKey;
    },
    generateNewApiKey() {
      this.settingAPI.apiKey = this.generateRandomApiKey();
    },
    toggleApiKeyVisibility() {
      this.showApiKey = !this.showApiKey;
    },
    copyApiKey() {
      navigator.clipboard.writeText(this.settingAPI.apiKey).then(() => {
        console.log("API Key copied to clipboard!");
      }).catch((error) => {
        console.error("Failed to copy API Key:", error);
      });
    },
  },
  async mounted() {
    this.listenToAPISetting();
  },
};
</script>

<style lang="scss">
.row-wrapper {
  padding-left: 20px;
}
</style>
